/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Nothing_New_ContentInputs */

const en_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The items currently on display are the only ones you haven’t unlocked yet. Check back occasionally. We add new items from time to time!`)
};

const ar_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنتجات المعروضة حاليًا هي الوحيدة التي لم تفتح قفلها بعد. تحقّق مجددًا من حين لآخر، فقد نضيف منتجات جديدة أحيانًا!`)
};

const de_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die angezeigten Artikel sind die einzigen, die du noch nicht freigeschaltet hast. Schau gelegentlich wieder vorbei. Es kommen immer mal wieder neue Artikel hinzu!`)
};

const es_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los artículos que ves ahora son los únicos que aún no has desbloqueado. Vuelve de vez en cuando. Añadimos nuevos artículos periódicamente.`)
};

const fr_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les articles affichés sont les seuls que vous n’avez pas encore débloqués. Revenez de temps en temps. Nous ajoutons de nouveaux articles de temps à autre !`)
};

const it_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli articoli mostrati sono gli unici che non hai ancora sbloccato. Torna a dare un’occhiata ogni tanto. Aggiungiamo periodicamente nuovi articoli!`)
};

const ja_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`現在表示されている商品以外は、すべてアンロック済みです！新しい商品は不定期に追加されるので、時々チェックしてみてください。`)
};

const ko_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`현재 표시된 상품을 제외한 나머지 상품은 모두 잠금 해제했어요! 새로운 상품은 비정기적으로 추가되니 가끔 다시 확인해 보세요.`)
};

const pt_br_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os itens exibidos agora são os únicos que você ainda não desbloqueou. Volte de vez em quando. Adicionamos novos itens periodicamente!`)
};

const ru_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Из всех товаров вы ещё не разблокировали только те, что сейчас на экране. Заглядывайте время от времени. Мы периодически добавляем новые товары!`)
};

const th_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สินค้าที่แสดงอยู่ตอนนี้คือสินค้าทั้งหมดที่คุณยังไม่ได้ปลดล็อก แวะกลับมาดูเป็นครั้งคราวนะ เราจะเพิ่มสินค้าใหม่เป็นระยะ`)
};

const tr_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şu anda gösterilen ürünler, henüz kilidini açmadığın ürünlerin tümü. Ara sıra tekrar göz at. Zaman zaman yeni ürünler ekliyoruz!`)
};

const zh_cn_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除了架上商品外，其他商品你都解锁了！记得偶尔回来看看，我们会不定期新增哦！`)
};

const zh_tw_dialog_nothing_new_content = /** @type {(inputs: Dialog_Nothing_New_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`除了架上商品外，其他商品你都解鎖了！記得偶爾回來看看，我們會不定期新增喔！`)
};

/**
* | output |
* | --- |
* | "The items currently on display are the only ones you haven’t unlocked yet. Check back occasionally. We add new items from time to time!" |
*
* @param {Dialog_Nothing_New_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_nothing_new_content = /** @type {((inputs?: Dialog_Nothing_New_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Nothing_New_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_nothing_new_content(inputs)
	if (locale === "ar") return ar_dialog_nothing_new_content(inputs)
	if (locale === "de") return de_dialog_nothing_new_content(inputs)
	if (locale === "es") return es_dialog_nothing_new_content(inputs)
	if (locale === "fr") return fr_dialog_nothing_new_content(inputs)
	if (locale === "it") return it_dialog_nothing_new_content(inputs)
	if (locale === "ja") return ja_dialog_nothing_new_content(inputs)
	if (locale === "ko") return ko_dialog_nothing_new_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_nothing_new_content(inputs)
	if (locale === "ru") return ru_dialog_nothing_new_content(inputs)
	if (locale === "th") return th_dialog_nothing_new_content(inputs)
	if (locale === "tr") return tr_dialog_nothing_new_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_nothing_new_content(inputs)
	return zh_tw_dialog_nothing_new_content(inputs)
});